import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';
import { cn } from '@/utils/cn';
import { BANNER_SHAPE_CLASS } from './DefaultBanners';

const BANNER_PAGINATION_DOT_COUNT = 3;

export default function BannersSkeleton() {
  return (
    <div className="-mx-4 px-4">
      <SkeletonParent className={cn(BANNER_SHAPE_CLASS, '[container-type:inline-size]')}>
        <div
          className="absolute bottom-0 left-[3.7cqw] z-[2] h-full w-full flex flex-col py-[3.4cqw] max-sm:pt-[4.6cqw] max-sm:pb-[1cqw] max-sm:pl-[0.5cqw] max-sm:left-[4.5cqw]"
        >
          <div className="flex flex-col mb-5 max-sm:mb-[1.9cqw]">
            <SkeletonChild className="h-[1.9cqw] max-sm:h-[6.1cqw] mb-[1.8cqw] w-[22.8cqw] max-sm:w-[44.2cqw] max-sm:mb-[1.9cqw] rounded-[0.5rem]" />
            <SkeletonChild className="h-[4.4cqw] max-sm:h-[9.2cqw] w-[35.7cqw] max-sm:w-[61cqw] rounded-[0.5rem]" />
          </div>

          <SkeletonChild className="h-[4.4cqw] max-sm:h-[9.2cqw] w-[26.3cqw] max-sm:w-[45.2cqw] rounded-[0.5rem] mb-6.5 max-sm:mb-[11.3cqw]" />

          <SkeletonChild className="h-[4cqw] max-sm:h-[10cqw] w-[24cqw] max-sm:w-[37.8cqw] rounded-full" />
        </div>
      </SkeletonParent>
      <div className="px-4 mb-1 flex justify-center gap-1.25 py-3">
        {Array.from({ length: BANNER_PAGINATION_DOT_COUNT }, (_, idx) => (
          <SkeletonParent
            key={idx}
            aria-hidden
            className="h-1.25 rounded-full"
            style={{ width: idx === 0 ? 'clamp(1.4375rem, 6vw, 2.5rem)' : '0.3125rem' }}
          />
        ))}
      </div>
    </div>
  );
}
